import { useEffect, useState, useRef } from "react";
import { useDispatch } from 'react-redux';
import { Row, Col, Image, InputGroup } from "react-bootstrap";
import Logo from "Images/PSOPPC-logo-only.png";
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import { Form, Button } from "react-bootstrap";
import ChatMessage from "./ChatMessage";
import ChatbotDisclaimerPopup from "./ChatbotDisclaimerPopup";
import ChatbotTopicDropdown from "./ChatbotTopicDropdown";
import RemoveIcon from '@mui/icons-material/Remove';
import { query } from "./ChatbotAxiosFuncs";
import { STATUSES, ERROR_MESSAGES } from "Utils/constants";
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import { buildTimestamp, WELCOME_MESSAGE } from "./ChatbotUtils";

const ChatbotWindow = ({
  isOpen,
  handleClose,
  handleMinimize,
  resetChatbotChannel,
  suggestionTopicMsg,
  chatbotInfoStorage,
  setChatbotInfoStorage
}) => {

  const dispatch = useDispatch();

  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [chatMessage, setChatMessage] = useState("");
  const [resMessageList, setResMessageList] = useState([]);
  const [isThinking, setIsThingking] = useState(false);
  const chatWindowBottomRef = useRef(null);

  const handleChatMessage = (e) => {
    setChatMessage(e.target.value);
  }

  const handleChatMessageByKey = (e, msg) => {

    // Enter key code: 13
    if ((e.keyCode == 13) && msg) {
      setIsThingking(true);
      // set message request
      // Ex. for the message request
      // {
      //   "message": "what is implementation guide",
      //   "topic": -1,
      //   "sessionId": "3cfac7d7-c65b-4aa7-a3f1-d0e68795dd99",
      //   "resetMemory": false
      // }

      let request = {
        "message": msg,
        "topic": chatbotInfoStorage.topicId,
        "sessionId": chatbotInfoStorage.sessionId,
        "resetMemory": chatbotInfoStorage.resetMemory
      }

      //dispay the the user's end chat message in the chatbot window
      let question = {
        "message": msg,
        "chatId": null,
        "documents": [],
        "webpages": [],
        "reset_memory": false,
        "session_id": chatbotInfoStorage.sessionId,
        "timestamp": buildTimestamp()
      }

      // !!! if reset memory is true, set it to be false since it can not be true all the time
      localStorage.setItem("chatbot_info_storage", JSON.stringify({
        ...chatbotInfoStorage,
        messageList: [
          ...chatbotInfoStorage.messageList,
          question
        ],
        resetMemory: false
      }));
      setChatbotInfoStorage({
        ...chatbotInfoStorage,
        messageList: [
          ...chatbotInfoStorage.messageList,
          question
        ],
        resetMemory: false
      });

      // Ex. response/answer
      // {
      //   "answer": "chatbot  generated text answer",
      //   "chatId": 5
      //   "documents": [
      //      {
      //          "doc_name": "",
      //          "groupId": 140
      //      }]
      //   "webpages": [
      //    {description: '', url: ''}
      //   ]
      // }

      // get the ai response and display it in the chat window 
      query(request).then((res) => {
        var statusCode = res.data.status;
        if (statusCode < 0) {
          statusCode = STATUSES.ERROR.code;
        }
        switch (statusCode) {
          case STATUSES.ERROR.code:
            // TODO!!!: how do we handle the global erros in the chat window
            if (res.data.globalErrorMessageList && res.data.globalErrorMessageList.length != 0) {
              setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                  visible: true,
                  title: ERROR_MESSAGES.GENERAL_ERROR.title,
                  msg: res.data.globalErrorMessageList,
                  showContactHelp: false
                },
                redirect: {
                  redirect: false,
                  redirectFirst: false,
                  path: "",
                  data: {}
                }
              })
            };
            setIsThingking(false);
            break;
          case STATUSES.SUCCESS.code:

            let data = res.data.data;
            let answer = {
              "message": data.answer,
              "chatId": data.chatId,
              "documents": data.documents,
              "webpages": data.webpages,
              "reset_memory": false,
              "session_id": chatbotInfoStorage.sessionId,
              "timestamp": buildTimestamp(),
              "isThumbUp": false,
              "isThumbDown": false,
            }

            setResMessageList([
              ...resMessageList,
              answer
            ]);

            break;
        }
        return;
      }).catch((error) => {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });
        setIsThingking(false);
      });

      // clear the input box
      setChatMessage("");
    }
  }

  const handleChatMessageByClick = (msg) => {
    if (msg) {
      setIsThingking(true);

      let request = {
        "message": msg,
        "topic": chatbotInfoStorage.topicId,
        "sessionId": chatbotInfoStorage.sessionId,
        "resetMemory": chatbotInfoStorage.resetMemory
      }

      //dispay the the user's end chat message in the chatbot window
      let question = {
        "message": msg,
        "chatId": null,
        "documents": [],
        "webpages": [],
        "reset_memory": false,
        "session_id": chatbotInfoStorage.sessionId,
        "timestamp": buildTimestamp()
      }

      // !!! if reset memory is true, set it to be false since it can not be true all the time
      localStorage.setItem("chatbot_info_storage", JSON.stringify({
        ...chatbotInfoStorage,
        messageList: [
          ...chatbotInfoStorage.messageList,
          question
        ],
        resetMemory: false
      }));
      setChatbotInfoStorage({
        ...chatbotInfoStorage,
        messageList: [
          ...chatbotInfoStorage.messageList,
          question
        ],
        resetMemory: false
      });

      // get the ai response and display it in the chat window 
      query(request).then((res) => {
        var statusCode = res.data.status;
        if (statusCode < 0) {
          statusCode = STATUSES.ERROR.code;
        }
        switch (statusCode) {
          case STATUSES.ERROR.code:
            // TODO!!!: how do we handle the global erros in the chat window
            if (res.data.globalErrorMessageList && res.data.globalErrorMessageList.length != 0) {
              setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                  visible: true,
                  title: ERROR_MESSAGES.GENERAL_ERROR.title,
                  msg: res.data.globalErrorMessageList,
                  showContactHelp: false
                },
                redirect: {
                  redirect: false,
                  redirectFirst: false,
                  path: "",
                  data: {}
                }
              })
            };
            setIsThingking(false);
            break;
          case STATUSES.SUCCESS.code:

            let data = res.data.data;
            let answer = {
              "message": data.answer,
              "chatId": data.chatId,
              "documents": data.documents,
              "webpages": data.webpages,
              "reset_memory": false,
              "session_id": chatbotInfoStorage.sessionId,
              "timestamp": buildTimestamp(),
              "isThumbUp": false,
              "isThumbDown": false,
            }

            setResMessageList([
              ...resMessageList,
              answer
            ]);

            break;
        }
      }).catch((error) => {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });
        setIsThingking(false);
      });

      // clear the input box
      setChatMessage("");
    }
  }

  // show/hide disclaimer popup by enter key
  const handleDisclaimerByKey = (e, show) => {
    // Enter key code: 13
    if (e.keyCode == 13) {
      setShowDisclaimer(!show);
    }
  }

  const handleResetConversation = () => {
    // clean chatbot message list
    WELCOME_MESSAGE.timestamp = buildTimestamp();
    localStorage.setItem("chatbot_info_storage", JSON.stringify({
      ...chatbotInfoStorage,
      topicId: -1,
      messageList: [
        WELCOME_MESSAGE
      ]
    }));
    setChatbotInfoStorage({
      ...chatbotInfoStorage,
      topicId: -1,
      messageList: [
        WELCOME_MESSAGE
      ]
    });

    resetChatbotChannel.postMessage({
      ...chatbotInfoStorage,
      topicId: -1,
      messageList: [
        WELCOME_MESSAGE
      ]
    });
  }

  const handleResetConversationByKey = (e) => {
    // Enter key code: 13
    if (e.keyCode == 13) {
      handleResetConversation();
    }
  }

  const closeWindow = () => {
    setResMessageList([]);
    handleClose();
  }

  // scroll to the bottom of chat windo when open the chat window
  useEffect(() => {
    if (isOpen) {
      chatWindowBottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [isOpen]);

  // scroll to the bottom of chat window when new message comes in
  useEffect(() => {
    chatWindowBottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chatbotInfoStorage.messageList]);

  // handle the async message response from the user's multiple input questions without waiting for the ai response
  useEffect(() => {
    let answer = resMessageList[resMessageList.length - 1];
    if (answer) {
      localStorage.setItem("chatbot_info_storage", JSON.stringify({
        ...chatbotInfoStorage,
        messageList: [
          ...chatbotInfoStorage.messageList,
          answer
        ]
      }));
      setChatbotInfoStorage({
        ...chatbotInfoStorage,
        messageList: [
          ...chatbotInfoStorage.messageList,
          answer
        ]
      });

      resetChatbotChannel.postMessage({
        ...chatbotInfoStorage,
        messageList: [
          ...chatbotInfoStorage.messageList,
          answer
        ]
      });
    }
    setIsThingking(false);
  }, [resMessageList]);

  useEffect(() => {
    if (suggestionTopicMsg) {
      //console.log("get suggetsion topic msg", suggestionTopicMsg);
      setIsThingking(true);
      let request = {
        "message": suggestionTopicMsg,
        "topic": chatbotInfoStorage.topicId,
        "sessionId": chatbotInfoStorage.sessionId,
        "resetMemory": chatbotInfoStorage.resetMemory
      }

      //dispay the the user's end chat message in the chatbot window
      let question = {
        "message": suggestionTopicMsg,
        "chatId": null,
        "documents": [],
        "webpages": [],
        "reset_memory": false,
        "session_id": chatbotInfoStorage.sessionId,
        "timestamp": buildTimestamp()
      }

      localStorage.setItem("chatbot_info_storage", JSON.stringify({
        ...chatbotInfoStorage,
        messageList: [
          ...chatbotInfoStorage.messageList,
          question
        ]
      }));
      setChatbotInfoStorage({
        ...chatbotInfoStorage,
        messageList: [
          ...chatbotInfoStorage.messageList,
          question
        ]
      });

      resetChatbotChannel.postMessage({
        ...chatbotInfoStorage,
        messageList: [
          ...chatbotInfoStorage.messageList,
          question
        ]
      });

      // get the ai response and display it in the chat window 
      query(request).then((res) => {
        var statusCode = res.data.status;
        if (statusCode < 0) {
          statusCode = STATUSES.ERROR.code;
        }
        switch (statusCode) {
          case STATUSES.ERROR.code:
            // TODO!!!: how do we handle the global erros in the chat window
            if (res.data.globalErrorMessageList && res.data.globalErrorMessageList.length != 0) {
              setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                  visible: true,
                  title: ERROR_MESSAGES.GENERAL_ERROR.title,
                  msg: res.data.globalErrorMessageList,
                  showContactHelp: false
                },
                redirect: {
                  redirect: false,
                  redirectFirst: false,
                  path: "",
                  data: {}
                }
              })
            };
            setIsThingking(false);
            break;
          case STATUSES.SUCCESS.code:

            let data = res.data.data;
            let answer = {
              "message": data.answer,
              "chatId": data.chatId,
              "documents": data.documents,
              "webpages": data.webpages,
              "reset_memory": false,
              session_id: chatbotInfoStorage.sessionId,
              "timestamp": buildTimestamp(),
              "isThumbUp": false,
              "isThumbDown": false,
            }

            setResMessageList([
              ...resMessageList,
              answer
            ]);

            break;
        }
      }).catch((error) => {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });
        setIsThingking(false);
      });
    }
  }, [suggestionTopicMsg]);

  return (
    <>
      <ChatbotDisclaimerPopup showDisclaimer={showDisclaimer} closeDisclaimer={() => setShowDisclaimer(false)}></ChatbotDisclaimerPopup>
      {isOpen ?
        <div className="chatbot-window">
          {/* window header */}
          <div className="chatbot-window-header d-flex align-items-center justify-content-between">
            <div className="chatbot-window-title d-flex align-items-center">
              <Image
                className="ms-1 me-3"
                alt="PSOPPC Logo"
                src={Logo}
                width={"22px"}
                height={"22px"}
              />
              PSOPPC Chatbot
            </div>
            {/* window buttons: minimize, close */}
            <div>
              <Button
                aria-label="minize the chat window"
                className="p-1"
                onClick={handleMinimize}
              >
                <RemoveIcon />
              </Button>
              <Button
                aria-label="close the chat window"
                className="p-1"
                onClick={closeWindow}
              >
                <CloseIcon />
              </Button>
            </div>
          </div>
          {/* dropdown */}
          <div className="chatbot-dropdown">
            <ChatbotTopicDropdown
              chatbotInfoStorage={chatbotInfoStorage}
              setChatbotInfoStorage={setChatbotInfoStorage}
              resetChatbotChannel={resetChatbotChannel}
            >
            </ChatbotTopicDropdown>
          </div>
          {/* window body */}
          <div className="chatbot-window-body">
            {/* welcome */}
            <div className="d-flex justify-content-center mb-3">
              <Image
                className="me-2"
                alt="PSOPPC Logo"
                src={Logo}
                width={"68px"}
                height={"68px"}
              />
            </div>
            <div className="text-center welcome-title mb-1">
              PSOPPC Chatbot
            </div>
            <div className="text-center mb-3">
              Hi! 👋 Welcome to PSOPPC.
            </div>
            {/* messages */}
            {chatbotInfoStorage.messageList.map((item, index) => (
              <ChatMessage
                message={item}
                resetChatbotChannel={resetChatbotChannel}
                chatbotInfoStorage={chatbotInfoStorage}
                setChatbotInfoStorage={setChatbotInfoStorage}
              >
              </ChatMessage>
            )
            )}
            {/* thinking */}
            {isThinking ?
              <div className="d-flex chatbot-message-left mb-2">
                {/* logo */}
                <div className="mt-auto">
                  <span className="chatbot-icon d-flex align-items-center justify-content-center">
                    <Image
                      alt="PSOPPC Logo" src={Logo}
                      height={"16px"}
                      width={"16px"}
                    />
                  </span>
                </div>
                {/* message content */}
                <div className="ms-2 chatbot-think-content">
                  {/* text */}
                  <div className="mt-2">Thinking...</div>
                </div>
              </div> : null}
            <div ref={chatWindowBottomRef}></div>
          </div>
          {/* window footer */}
          <div className="chatbot-window-footer">
            {/* Input box */}
            <div>
              <Form.Group
                controlId="chatMessage"
              >
                <InputGroup>
                  <Form.Control
                    aria-label="input text"
                    style={{ borderRight: "none" }}
                    type="text"
                    placeholder="Click here to start typing"
                    value={chatMessage}
                    onChange={(e) => handleChatMessage(e)}
                    onKeyDown={(e) => handleChatMessageByKey(e, chatMessage)}
                  />
                  <InputGroup.Text>
                    <Button
                      aria-label="send message"
                      onClick={() => handleChatMessageByClick(chatMessage)}
                    >
                      <SendIcon className="send-icon" />
                    </Button>
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </div>
            <Row className="text-center mt-3 d-flex flex-nowrap">
              <Col
                className="d-md-none d-lg-block"
              >
                {/* reset conversation */}
                <Button
                  className="reset-button p-0 p-1 d-inline"
                  onClick={() => handleResetConversation()}
                  onKeyDown={(e) => handleResetConversationByKey(e)}
                >
                  Reset Conversation
                </Button>
                |
                {/* disclaimer */}
                <Button
                  className="disclaimer-link p-0 p-1 d-inline"
                  onClick={() => setShowDisclaimer(true)}
                  onKeyDown={(e) => handleDisclaimerByKey(e, showDisclaimer)}
                >
                  View Our Disclaimer
                </Button>
              </Col>
              <Col
                className="d-none d-md-block d-lg-none"
              >
                {/* reset conversation */}
                <Button
                  className="reset-button p-0 p-1 m-0 me-1 d-inline"
                  onClick={() => handleResetConversation()}
                  onKeyDown={(e) => handleResetConversationByKey(e)}
                >
                  Reset Conversation
                </Button>
                {/* disclaimer */}
                <Button
                  className="disclaimer-link p-0 p-1 m-0 ms-1 d-inline"
                  onClick={() => setShowDisclaimer(true)}
                  onKeyDown={(e) => handleDisclaimerByKey(e, showDisclaimer)}
                >
                  View Our Disclaimer
                </Button>
              </Col>
            </Row>
          </div>
        </div>
        : null
      }
    </>
  )
}

export default ChatbotWindow;